export default "__VITE_ASSET__BtlpetHU__"